import { useMutation } from "urql";
import {
  UpdateIsPrivateMutationMutation,
  UpdateIsPrivateMutationMutationVariables,
} from "../gql/graphql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

export function useUpdateIsPrivateMutation() {
  return useMutation(updateIsPrivateMutation);
}

export const updateIsPrivateMutation: TypedDocumentNode<
  UpdateIsPrivateMutationMutation,
  UpdateIsPrivateMutationMutationVariables
> = graphql(`
  mutation updateIsPrivateMutation(
    $identifier: String!
    $isPrivateCrew: Boolean!
    $bucket: String!
  ) {
    updateIsPrivate(
      identifier: $identifier
      isPrivateCrew: $isPrivateCrew
      bucket: $bucket
    ) {
      identifier
    }
  }
`);
